'use strict';

import template from '../../templates/settings/LeaveTypeModal.ejs';
import ModalFormView from 'commons/views/ModalForm';

module.exports = ModalFormView.extend({
    initialize: function(options) {
        this.options = _.defaults(options || {}, {template: template});
        return ModalFormView.prototype.initialize.apply(this, [this.options]);
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/LeaveTypeModal.js